import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  get_failure,
  get_request,
  get_success,
} from "../Redux/getReducer/action";

export default function KanbanBoard() {
  const [render, setRender] = useState(false);
  const [name, setName] = useState("");
  const [BoardId, setBoardId] = useState("");
  const [todo, setTodo] = useState([]);
  const [doing, setDoing] = useState([]);
  const [done, setDone] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("");

  const onOpen = () => {
    setIsOpen(true); // Open the first drawer
  };

  const onClose = () => {
    setIsOpen(false); // Close the first drawer
  };
  let data = useSelector((store) => store.getReducer.data);
  // console.log(data)
  const dispatch = useDispatch();
  const fetch = () => {
    dispatch(get_request());
    axios
      .get(`https://vast-cyan-lion-gear.cyclic.app/boards/`)
      .then((res) => {
        dispatch(get_success(res.data.msg));
      })
      .catch((err) => {
        dispatch(get_failure());
        console.log(err);
      });
  };

  const CreateBoard = () => {
    let obj = {
      name,
    };
    console.log(obj);
    axios
      .post(`https://vast-cyan-lion-gear.cyclic.app/boards/`, obj)
      .then((res) => {
        console.log(res.data);
        setName("");
        setRender(!render);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getBoardData = (Id) => {
    setBoardId(Id);
    axios
      .get(`https://vast-cyan-lion-gear.cyclic.app/boards/${Id}`)
      .then((res) => {
        console.log(res.data.msg.tasks);

        let t = res.data.msg.tasks.filter((ele) => ele.status == "Todo");
        let doing = res.data.msg.tasks.filter((ele) => ele.status == "Doing");
        let don = res.data.msg.tasks.filter((ele) => ele.status == "Done");
        setTodo(t);
        setDoing(doing);
        setDone(don);
        setRender(!render);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addNewTask = () => {
    const obj = {
      title,
      description,
      status,
    };
    axios
      .post(`https://vast-cyan-lion-gear.cyclic.app/boards/${BoardId}/tasks`, obj)
      .then((res) => {
        console.log(res.data);
        setRender(!render);
        getBoardData(BoardId);
        setTitle("");
        setDescription("");
        setStatus("");
        onClose();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDelete = (id) => {
    console.log(id);
    axios.delete(`https://vast-cyan-lion-gear.cyclic.app/boards/tasks/${id}`)
    .then((res)=>{
      console.log(res.data)
      getBoardData(BoardId);
    })
    .catch((err)=>{

    })
  };
  console.log(doing, "doinfuyg");
  useEffect(() => {
    fetch();
  }, [render]);
  return (
    <Box display={"flex"}>
      <Box
        border={"2px solid black"}
        marginLeft={"10px"}
        marginTop={"10px"}
        marginRight={"10px"}
      >
        {data.length > 0 && data ? (
          <Box display={"grid"}>
            {data.map((ele) => (
              <Button
                colorScheme="blue"
                marginTop={"10px"}
                onClick={() => getBoardData(ele._id)}
              >
                <Heading as="h3" size="lg">
                  {ele.name}
                </Heading>
              </Button>
            ))}
          </Box>
        ) : (
          <Heading as="h3" size="lg">
            Loading....
          </Heading>
        )}
        <Input
          placeholder="Create Boarder"
          marginTop={"30px"}
          onChange={(e) => setName(e.target.value)}
        />
        <Button marginTop={"10px"} width={"100%"} onClick={CreateBoard}>
          Create Board
        </Button>
      </Box>
      <Box>
        <Box>
          <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Add New Task</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <FormControl>
                  <FormLabel>Title</FormLabel>
                  <Input
                    onChange={(e) => {
                      setTitle(e.target.value);
                    }}
                    value={title}
                    type="text"
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Description</FormLabel>
                  <Input
                    onChange={(e) => {
                      setDescription(e.target.value);
                    }}
                    value={description}
                    type="text"
                    aria-label="Description for your input field"
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Status</FormLabel>
                  <Select
                    onChange={(e) => {
                      setStatus(e.target.value);
                    }}
                    value={status}
                    placeholder="Select Status"
                  >
                    <option value="Todo">Todo</option>
                    <option value="Done">Done</option>
                    <option value="Doing">Doing</option>
                  </Select>
                </FormControl>
              </ModalBody>

              <ModalFooter>
                <Button colorScheme="blue" mr={3} onClick={onClose}>
                  Close
                </Button>
                <Button variant="ghost" onClick={addNewTask}>
                  Create
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

          <Button onClick={onOpen}>
            <Button>Add Tasks</Button>
          </Button>

          <TableContainer marginTop={"20px"}>
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Todo</Th>
                  <Th>Doing</Th>
                  <Th>Done</Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td>
                    {todo.length > 0 && todo ? (
                      <Box>
                        {todo.map((ele) => (
                          <Box>
                            <Heading as="h4" size="md">
                              {ele.title}
                            </Heading>
                            <Heading as="h6" size="xs" marginTop={"10px"}>
                              No of Subtes: {ele.subtasks.length}
                            </Heading>
                            <Button colorScheme="gray" marginTop={"10px"}>
                              Edit
                            </Button>
                            <Button
                              colorScheme="red"
                              onClick={() => handleDelete(ele._id)}
                            >
                              Delete
                            </Button>
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <Box></Box>
                    )}
                  </Td>

                  <Td>
                    {doing.length > 0 && doing ? (
                      <Box>
                        {doing.map((ele) => (
                          <Box>
                            <Heading as="h4" size="md">
                              {ele.title}
                            </Heading>
                            <Heading as="h6" size="xs" marginTop={"10px"}>
                              No of Subtes: {ele.subtasks.length}
                            </Heading>
                            <Button colorScheme="gray" marginTop={"10px"}>
                              Edit
                            </Button>
                            <Button
                              colorScheme="red"
                              onClick={() => handleDelete(ele._id)}
                            >
                              Delete
                            </Button>
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <Box></Box>
                    )}
                  </Td>

                  <Td>
                    {done.length > 0 && done ? (
                      <Box>
                        {done.map((ele) => (
                          <Box>
                            <Heading as="h4" size="md">
                              {ele.title}
                            </Heading>
                            <Heading as="h6" size="xs" marginTop={"10px"}>
                              No of Subtes: {ele.subtasks.length}
                            </Heading>
                            <Button colorScheme="gray" marginTop={"10px"}>
                              Edit
                            </Button>
                            <Button
                              colorScheme="red"
                              onClick={() => handleDelete(ele._id)}
                            >
                              Delete
                            </Button>
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <Box></Box>
                    )}
                  </Td>
                </Tr>
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Box>
  );
}
